import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import { toast } from "react-toastify";
class QuartierForm extends Component{
    state = { id:null, name:"", communeId:"", groupmentId:"", error:"", communes:[], quartiers:[], groupments:[] }

    handleInput = (e) => this.setState({ [e.target.name]: e.target.value });

    async communes(){
        const request = await axios('communes');
        if(request.status === 200) this.setState({ communes:request.data });
    }

    async quartiers(){
        const request = await axios('quartiers');
        if(request.status === 200) this.setState({ quartiers:request.data });
    }

    async groupments(){
        const request = await axios('groupments');
        if(request.status === 200) this.setState({ groupments:request.data });
    }

    storeTerritory = () => {
        const data = { groupmentId:this.state.groupmentId, communeId:this.state.communeId, name:this.state.name };
        const request = this.state.id ? axios.put('quartiers/'+this.state.id, data) : axios.post('quartiers', data);
        request.then((response) => {
            this.props.showModal(response.data.data);
            toast(response?.data?.msg, { theme:"light", style:{ backgroundColor:"blue", color:"white" } });
        }).catch((error) => {
            this.setState({ error:error.response?.data?.msg || "Une erreur est survenue." });
            toast(error.response?.data?.msg, { theme:"light", style:{ backgroundColor:"red", color:"white" } });
        });
    }

    edit = () => {
        this.form();
        this.groupments();
        this.communes();
        this.quartiers();
    }

    form = () => this.setState({
        id:this.props.formData ? this.props.formData.id : null,
        communeId:this.props.formData ? this.props.formData.communeId : "",
        groupmentId:this.props.formData ? this.props.formData.groupmentId : "",
        name:this.props.formData ? this.props.formData.name : "",
        error:"",
    });

    render(){
        return(
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                size="lg"
                dialogClassName="student-form-dialog commune-form-dialog"
                contentClassName="student-form-modal student-form-modal--compact"
                onEntered={this.edit}
                backdrop="static"
            >
                <Modal.Header>
                    <div className="student-form__heading">
                        <span className="student-form__heading-icon"><FeatherIcon icon="home" size="20" /></span>
                        <div>
                            <span className="student-form__eyebrow">Référentiel géographique</span>
                            <Modal.Title>{this.state.id ? "Modifier le quartier" : "Nouveau quartier"}</Modal.Title>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="student-form__body commune-form__body">
                    {this.state.error && (
                        <div className="student-form__alert" role="alert">
                            <FeatherIcon icon="alert-circle" size="17" />
                            <span>{this.state.error}</span>
                        </div>
                    )}

                    <div className="commune-form__grid">
                        <section className="commune-form__panel">
                            <div className="student-form__section-title">
                                <span><FeatherIcon icon="map" size="15" /></span>
                                <div>
                                    <strong>Quartiers enregistrés</strong>
                                    <small>Sélectionnez un quartier pour le modifier.</small>
                                </div>
                            </div>
                            <div className="commune-form__list">
                                {this.state.quartiers.length > 0 ? this.state.quartiers.map((quartier) => (
                                    <button
                                        type="button"
                                        key={quartier.id}
                                        className={`commune-form__item${this.state.id === quartier.id ? " is-active" : ""}`}
                                        onClick={() => this.setState({ id:quartier.id, communeId:quartier.communeId, groupmentId:quartier.groupmentId, name:quartier.name, error:"" })}
                                    >
                                        <span><FeatherIcon icon="home" size="15" /></span>
                                        <strong>{quartier.name} <small><em>{ quartier.commune?.name }</em></small></strong> { quartier.groupment?.name }
                                        <FeatherIcon icon="chevron-right" size="15" />
                                    </button>
                                )) : (
                                    <div className="commune-form__empty">
                                        <FeatherIcon icon="map" size="24" />
                                        <span>Aucun quartier enregistré</span>
                                    </div>
                                )}
                            </div>
                        </section>

                        <section className="commune-form__panel">
                            <div className="student-form__section-title">
                                <span><FeatherIcon icon="edit-3" size="15" /></span>
                                <div>
                                    <strong>Informations du quartier</strong>
                                    <small>Associez le quartier à sa commune et son groupement.</small>
                                </div>
                            </div>
                            <div className="commune-form__fields">
                                <div className="form-group has-icon-left">
                                    <label htmlFor="quartier-commune">Commune</label>
                                    <div className="position-relative">
                                        <select id="quartier-commune" name="communeId" className="form-control" onChange={this.handleInput} value={this.state.communeId || ""}>
                                            <option value="">Sélectionner une commune...</option>
                                            {this.state.communes.map((commune) => (
                                                <option key={commune.id} value={commune.id}>{commune.name}</option>
                                            ))}
                                        </select>
                                        <div className="form-control-icon"><FeatherIcon icon="navigation" /></div>
                                    </div>
                                </div>

                                <div className="form-group has-icon-left">
                                    <label htmlFor="quartier-groupment">Groupement</label>
                                    <div className="position-relative">
                                        <select id="quartier-groupment" name="groupmentId" className="form-control" onChange={this.handleInput} value={this.state.groupmentId || ""}>
                                            <option value="">Sélectionner un groupement...</option>
                                            {this.state.groupments.map((groupment) => (
                                                <option key={groupment.id} value={groupment.id}>{groupment.name}</option>
                                            ))}
                                        </select>
                                        <div className="form-control-icon"><FeatherIcon icon="layers" /></div>
                                    </div>
                                </div>

                                <div className="form-group has-icon-left">
                                    <label htmlFor="quartier-name">Nom du quartier</label>
                                    <div className="position-relative">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Ex. Quartier..."
                                            onChange={this.handleInput}
                                            name="name"
                                            value={this.state.name}
                                            id="quartier-name"
                                            autoFocus
                                        />
                                        <div className="form-control-icon"><FeatherIcon icon="home" /></div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <span className="student-form__footer-note">
                        <FeatherIcon icon="info" size="14" />
                        Le quartier sera disponible dans les listes géographiques
                    </span>
                    <button type="button" onClick={this.props.showModal} className="btn btn-light student-form__button">
                        <FeatherIcon icon="x" size="16" /> Fermer
                    </button>
                    <button type="button" onClick={this.storeTerritory} className="btn btn-primary student-form__button">
                        <FeatherIcon icon="check" size="16" /> Sauvegarder
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default QuartierForm;
